<script setup lang="ts">
type StudentUserData = App.Auth.Data.StudentUserData;
type TwoFactorChannelData = App.Auth.Data.TwoFactorChannelData;

import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';

import Button from '@/components/button/Button.vue';
import DangerDialog from '@/components/dialog/DangerDialog.vue';
import Dialog from '@/components/dialog/Dialog.vue';

import Check from '@/icons/line/check.svg';
import Trash from '@/icons/line/trash.svg';

const props = defineProps<{
  user: StudentUserData;
  channel: TwoFactorChannelData;
  channelsCount: number;
}>();

const { show } = useDialog();
const [isDeleteDialogOpen, toggleDeleteDialog] = useToggle(false);

const isDialogOpen = computed(() => !isDeleteDialogOpen.value && show.value);

const deleteForm = useForm({
  method: 'DELETE',
  url: route('student.profile.security.two-factor-authentication-channel.delete', {
    channel: props.channel.id
  }),
  fields: {}
});

const setDefaultForm = useForm({
  method: 'PUT',
  url: route('student.profile.two-factor-channel.default.update', {
    channel: props.channel.id
  }),
  fields: {}
});

function handleDeleteConfirm() {
  deleteForm.submit();
}

function handleSetAsDefault() {
  setDefaultForm.submit();
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog
    :title="channel.formattedDestination"
    :isOpen="isDialogOpen"
    hideFooter
    isStacked
    @onClose="
      router.navigate({
        url: route('student.profile.security.show')
      })
    "
  >
    <div class="flex w-full flex-col gap-y-3">
      <Button
        :color="ButtonColor.primary"
        :iconLeft="Check"
        :variant="ButtonVariant.soft"
        :size="ButtonSize.lg"
        :isDisabled="user.default_two_factor_channel_id === channel.id"
        :isLoading="setDefaultForm.processing"
        @click="handleSetAsDefault"
      >
        {{
          user.default_two_factor_channel_id === channel.id
            ? 'Primary method'
            : 'Set as primary method'
        }}
      </Button>
      <Button
        :color="ButtonColor.danger"
        :iconLeft="Trash"
        :isDisabled="channelsCount === 1"
        :variant="ButtonVariant.soft"
        :size="ButtonSize.lg"
        @click="toggleDeleteDialog"
      >
        Delete method
      </Button>
    </div>
  </Dialog>
  <DangerDialog
    title="Delete Two-Factor Method?"
    message="Are you sure you want to delete this two-factor authentication method? This action cannot be undone."
    :isOpen="isDeleteDialogOpen"
    :isLoading="deleteForm.processing"
    cancelButtonLabel="Keep method"
    confirmButtonLabel="Delete method"
    @onCancel="toggleDeleteDialog"
    @onClose="toggleDeleteDialog"
    @onConfirm="handleDeleteConfirm"
  />
</template>
